
import {Component, Vue, Prop} from "vue-property-decorator";
import {SelectGoodsOptionsDto} from "@/api/commonConfig";

const EVENT_ADD = 'add'

@Component({
    name: 'cart-control'
})
export default class CartControl extends Vue {
    @Prop() food: any

    add(event) {
        if (this.food.saleAmount >= this.food.maximum) return
        if (!this.food.saleAmount) {
            this.$set(this.food, 'saleAmount', 1)
        } else {
            this.food.saleAmount++
        }
        this.$emit(EVENT_ADD, event.target)
    }

    decrease() {
        if (this.food.saleAmount) {
            this.food.saleAmount--
        }
    }

}
